import React, { useEffect, useState, useRef, useMemo } from 'react'
import classNames from 'classnames'
import moment from 'moment'
import { Drawer, Spin } from 'antd'
import request from 'meinian-package/src/utils/request'
import Scroll from '@yk-component/yk-scroll'
import Icon from 'meinian-package/src/component/icon'
import { Empty } from 'meinian-package/src/baseComponent'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import { SystemInfo, MNInfoItem, BaseInfo } from './messageCard'
import useSocketMessage from './useSocketMessage'
import styles from './index.module.less'

export default ({ overlayStyle, style }) => {
  const [data, setData] = useState([])
  const [unReadNum, setUnReadNum] = useState()
  const [visible, setVisible] = useState(false)
  const [params] = useState({
    start: 0,
    pageSize: 20,
    viewed: null,
  })
  const [resultCount, setResultCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const $scrollRoot = useRef(null)
  const onInit = () => {
    fetchDataUnReadNum()
    fetchDataList({
      ...params,
      start: 0,
    })
  }
  useSocketMessage(onInit)

  useEffect(() => {
    fetchDataUnReadNum()
  }, [])

  useEffect(() => {
    emitter.on(EmitterEvents.onShowMessageNotification, () => {
      setVisible(true)
    })
    return () => {
      emitter.off(EmitterEvents.onShowMessageNotification)
    }
  }, [])
  useEffect(() => {
    if (visible) {
      fetchDataList()
    }
  }, [visible])

  const fetchDataUnReadNum = async () => {
    const res = await request.post('/backend-api/notify/website/notify/count-unread', { appCode: 'meinian', viewed: 0 })
    setUnReadNum(res.count)
  }

  const fetchDataList = async ({ start, pageSize, viewed } = params) => {
    setLoading(true)
    const res = await request.post(`/backend-api/notify/website/notify/page?start=${start}&pageSize=${pageSize}`, { appCode: 'meinian', viewed })
    if (start > 0) {
      setData([...data, ...res.resultList])
    } else {
      setData([...res.resultList])
    }
    setResultCount(res.resultCount)
    setLoading(false)
  }
  const onAllRead = async () => {
    const res = await request.post('/backend-api/notify/website/notify/read-notifies', {})
    if (res) {
      fetchDataList()
      fetchDataUnReadNum()
    }
  }

  const groupData = useMemo(() => {
    const groupObj = {}
    data.forEach(item => {
      const createTimeKey = moment(item.createdAt).format('YYYY年MM月DD')
      groupObj[createTimeKey] = groupObj[createTimeKey] || []
      groupObj[createTimeKey] = [...groupObj[createTimeKey], item]
    })
    return groupObj
  }, [data])

  return <div className={styles['mn-notice-info']}>
    <div
      style={{ position: 'relative',
        background: '#FFFFFF',
        borderRadius: '6px',
        cursor: 'pointer',
        ...overlayStyle }}
      onClick={() => setVisible(true)}
    >
      {unReadNum ? <div className="unreadnum">{unReadNum > 99 ? '99+' : unReadNum}</div> : null}
      <Tooltip title="消息">
        <div className={classNames('icon-button-wrap', { active: visible })}>
          <Icon type="m-xiaoxi" style={{ ...style }} />
        </div>
      </Tooltip>
    </div>
    <Drawer
      visible={visible}
      onClose={() => setVisible(false)}
      closable={false}
      width={520}
      className={styles['mn-drawer']}
    >
      <div className="mn-drawer-header">
        <div style={{ display: 'flex' }}>
          <div
            className={classNames('title-tab', { active: params.viewed === null })}
            onClick={() => {
              params.start = 0
              params.viewed = null
              fetchDataList({ ...params, viewed: null })
              $scrollRoot.current.scrollTop = 0
            }}
          >全部</div>
          <div
            className={classNames('title-tab', { active: params.viewed === 0 })}
            onClick={() => {
              params.start = 0
              params.viewed = 0
              fetchDataList(params)
              $scrollRoot.current.scrollTop = 0
            }}
          >未读 {unReadNum > 99 ? '99+' : unReadNum || 0}</div>
        </div>
        <div className="mn-drawer-header-right">
          {
            params.viewed === 0 && <div className={classNames('mn-drawer-header-right-read', { dialled: !unReadNum })} onClick={onAllRead}><Icon type="m-xiaoyan" className="mn-drawer-header-icon" />全部已读</div>
          }
          <div className="close" onClick={() => setVisible(false)}>
            <Icon type="m-guanbi" className="mn-drawer-header-close" />
          </div>
        </div>
      </div>
      <div className="mn-drawer-notice-content" ref={$scrollRoot}>
        <Scroll
          root={() => $scrollRoot.current}
          onEnd={() => {
            params.start += 20
            if (params.start < resultCount) {
              fetchDataList(params)
            }
          }}
          marginBottom={0}
          loading={loading}
          isEnd={false}
        >
          <div>
            <Spin spinning={loading}>
              {
                data.length ? Object.keys(groupData).map(key => (<List
                  key={key}
                  data={key}
                  groupData={groupData}
                  fetchDataUnReadNum={fetchDataUnReadNum}
                />))
                  : <Empty title="暂无消息" type="msg" />
              }
            </Spin>
          </div>
        </Scroll>
      </div>
    </Drawer>
  </div>
}

const List = ({ data, groupData, fetchDataUnReadNum }) => {
  const [visible, setVisible] = useState(true)
  return <>
    <div className="date-info-item" onClick={() => setVisible(!visible)}>
      {data}
      <Icon type={visible ? 'm-Vxing_shang' : 'm-Vxing_xia'} className="date-info-item-right" />
    </div>
    <div className="date-info-item-list" style={{ height: visible ? 'max-content' : 0 }}>
      {groupData[data].map(item => <InfoItem
        key={item.id}
        item={item}
        onInit={async () => {
          await fetchDataUnReadNum()
        }}
      />)}
    </div>
  </>
}

const infoEnum = {
  system_notify: SystemInfo,
  personal: MNInfoItem,
  system_remind: BaseInfo,
}

const InfoItem = ({ item, onInit }) => {
  if (infoEnum[item.type]) {
    const Component = infoEnum[item.type]
    return <Component key={item.id} item={item} onInit={onInit} />
  }
  return <MNInfoItem key={item.id} item={item} onInit={onInit} />
}
